function logPath(location, view) {
	// log the path even when not in development.  it won't take long and helps
	// with debugging on QA and production environments
	if (!location || !view) {
		return
	}

	var path = view.constructor.__filename__
	if (!path) {
		return
	}

	console.log(location + ': ' + path)
}

export default logPath

logPath.__filename__ = 'components/log-path.js'
